import equal from 'fast-deep-equal';
import {QueryKey, useQuery, useQueryClient} from '@tanstack/react-query';

import {apiClient} from '../../../../../utils/api-client';

import {StringSearch, NodeReferenceSearch} from './use-categories-query';

interface ResolvedCategory {
    categoryId: string;
    name: string;
}

export interface ResolvedCategoriesSearch {
    categories: ResolvedCategory[];
    includeUncategorized: boolean;
}

export interface SearchHistoryRecordDto {
    stringSearch: StringSearch | null;
    categoriesSearch: ResolvedCategoriesSearch | null;
    referencedNode: NodeReferenceSearch | null;
}

function getSearchHistoryRequest() {
    return apiClient.get<SearchHistoryRecordDto[]>({
        path: 'documents-revisions-service/api/user/documents/search-history'
    });
}

export function useExploreViewSearchHistoryQuery(enabled?: boolean) {
    return useQuery<SearchHistoryRecordDto[]>({
        queryKey: ['getSearchHistoryRequest'] as QueryKey,
        queryFn: getSearchHistoryRequest,
        enabled
    });
}

export function useExploreViewSearchHistoryQueryCache() {
    const queryClient = useQueryClient();

    function invalidate() {
        queryClient.invalidateQueries({queryKey: ['getSearchHistoryRequest']});
    }

    function addItem(data: SearchHistoryRecordDto) {
        queryClient.setQueryData<SearchHistoryRecordDto[]>(
            ['getSearchHistoryRequest'],
            (currentState = []) => {
                const state = currentState.filter((i) => !equal(i, data));

                return [data, ...state];
            }
        );
    }

    return {addItem, invalidate};
}
